/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

/**
 * Formats file size in bytes to human readable format (GB)
 */
export const formatFileSize = (bytes: number): string => {
	if (!bytes) return "-";
	try {
		const gb = Math.round((bytes * 100) / 1024 / 1024 / 1024) / 100;
		return `${gb} GB`;
	} catch {
		return "-";
	}
};

/**
 * Formats ISO date string to readable format
 */
export const formatDate = (dateString: string): string => {
	if (!dateString) return "-";
	try {
		const date = new Date(dateString);

		if (isNaN(date.getTime())) throw new Error("invalid date");

		return date.toLocaleDateString("en-US", {
			month: "short",
			day: "numeric",
			year: "numeric",
			timeZone: "UTC",
		});
	} catch {
		console.warn("formatDate: Invalid date string", dateString);
		return "-";
	}
};

/**
 * Validates if a URL string is a valid URL
 */
export const isValidUrl = (urlString: string): boolean => {
	if (!urlString || typeof urlString !== "string") {
		return false;
	}

	try {
		const url = new URL(urlString);
		// Ensure it's http or https protocol
		return url.protocol === "http:" || url.protocol === "https:";
	} catch {
		return false;
	}
};
